export default __webpack_public_path__ + "static/media/timeline-06.078c4c47.png";